
<div class="bar-container">
  <span
    :class="`bar-value bar-size-${value}`"
    :data-value="`${value / coef}${text}`"
    :style="`background-color: ${color};`"
  />
</div>
